'use client';

import React from 'react';

interface RoleLabelProps {
  propsIsWide?: boolean;
}

/**
 * OBOGラベル
 * @param param0
 * @returns
 */
const OBOGLabel: React.FC<RoleLabelProps> = ({ propsIsWide }) => {
  return (
    <>
      <span
        className={`${propsIsWide ? 'text-lg' : 'text-xs'} inline-flex items-center font-footballlog italic font-mideum bg-gray-400 border border-gray-400 text-white rounded px-2 py-1`}>
        OBOG
      </span>
    </>
  );
};

export default OBOGLabel;
